import type { FC } from 'react';
import styles from './SectionHeading.module.scss';

interface Props {
  title: string;
  description?: string;
}

/**
 * Heading for a Profile section (Password, Passkey, Authenticator app, Email). Matches the Figma
 * typography — title in Body/Medium (16px, weight 500) and an optional subtitle in Subheadline/Regular
 * (14px) — rather than the shared `Card.Title`, which renders a larger 20px bold heading used by the
 * auth flows.
 */
export const SectionHeading: FC<Props> = ({ title, description }) => (
  <div className={styles.heading}>
    <span className={styles.title}>{title}</span>
    {description && <span className={styles.description}>{description}</span>}
  </div>
);
